export const updateContentMediaLinks = (state = {}, action) => {
    const { datasource, data = {} } = action;

    if (datasource === 'schedule') {
        const { audio = {}, tv = {} } = data?.contentMediaLinks || {};
        const newData = {
            audio,
            tv
        };
        return Object.assign({}, state, newData);
    }

    return state;
};

export const updateMediaLinks = (state = {}, action) => {
    const { datasource, data = {} } = action;

    if (datasource === 'schedule') {
        const { audio = {}, tv = {} } = data?.mediaLinks || {};
        const newData = {
            audio,
            tv
        };
        return Object.assign({}, state, newData);
    }

    return state;
};

export default updateMediaLinks;
